/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client/core';

export const SENDBIRD_TOKEN_QUERY = gql`
  query SendbirdSessionToken {
    sendbirdSessionToken {
      expiresAt
      token
    }
  }
`;

export const SENDBIRD_UNREAD_MESSAGE_QUERY = gql`
  query {
    unreadMessageCount
  }
`;

export const SITTER_DETAILS_FOR_PARENT_QUERY = gql`
  query Account($accountId: UUID!) {
    account(id: $accountId) {
      ... on Sitter {
        canReview
        hasVisibleProfile
        providerType
      }
    }
  }
`;

export const FETCH_JOBS = gql`
  query ($expiresAfter: DateTime) {
    viewer(kind: PARENT) {
      ... on Parent {
        jobs(jobStatuses: [OPEN], expiresAfter: $expiresAfter) {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
`;
